
import { MainLayout } from "../components/layouts"
import { useState, useEffect } from "react"
import { Row, Col } from "reactstrap"
import { Card, ColorCircle, CustomButton, BackButton } from "../components"
import { COLORS, levelcolors } from "../constants"
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"
import axios from "axios"
import Close from "../assets/images/Close.svg"
import styled from "styled-components"
import Checkout from "./Checkout"


const StyledClose = styled.div`
    position: absolute;
    background-color: white;
    width: 40px;
    height: 40px;
    top: -15px;
    right: -15px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s;

    &:hover{
        box-shadow: none;
    }

`;
function Basket() {
    const api = process.env.REACT_APP_API_URL;
    const user = useSelector(state => state.auth.user.user)
    const [basketContents, setBasketContents] = useState([]);
    const [basketData, setBasketData] = useState(null);
    const [error, setError] = useState(false)

    useEffect(async () => {
        getBasketContents();
    }, [])
    const getBasketContents = async () => {
        const response = await axios.get(`${api}/ps/basket_contents/${user.email}`)
        const data = response.data;

        if (data.status_code == -1) {
            setError(true)
        } else {
            setBasketContents(data.basket_contents)
            setBasketData(data.basket)

        }
    }
    const Checkout = async () => {
        const response = await axios.post(`${api}/stripe/create_checkout_session`, { email_id: user.email })
        console.log(response.data)
        window.location.href = response.data.url;
        // const data = response.data;

        // if (data.status_code == -1) {
        //     setError(true)
        // } else {
        //     setBasketContents(data.basket_contents)
        //     setBasketData(data.basket)

        // }
    }
    const removeFromBasket = async (id, sku) => {
        const dataToRemove = {
            email_id: user.email,
            product_id: id,
            sku: sku
        }
        const response = await axios.post(`${api}/ps/remove_from_basket`, dataToRemove)
        const data = response.data;
        if (data) {
            getBasketContents()
        }

    }
    if (basketContents.length == 0 || error) {
        return <MainLayout>
            <div className="d-flex align-items-center mt-4">
                <BackButton to="/store" />
                <h4 className="mb-0 ml-4 color-text-dark-blue">Tell & Spell Store</h4>
            </div>

            <h5 className="mt-4 color-text-green">Items in Basket</h5>
            <h6 className="color-text-grey mt-3">Your shopping bag is empty</h6>
        </MainLayout>
    } else {


        return (
            <MainLayout>
                <div className="d-flex align-items-center mt-4">
                    <BackButton to="/store" />
                    <h4 className="mb-0 ml-4 color-text-dark-blue">Tell & Spell Store</h4>
                </div>

                <h5 className="mt-4 color-text-green">Items in Basket</h5>
                <Row>
                    <Col lg={8} className="mt-3">
                        {basketContents.map((item, i) => {
                            return <Card className="d-flex pt-3 pb-3 position-relative mb-3" key={i}>
                                <StyledClose className="shadow-md" onClick={() => removeFromBasket(item.product_id, item.sku)}>
                                    <img src={Close} />
                                </StyledClose>
                                <ColorCircle bgColor={levelcolors[item.level_no - 1].bgColor} color={levelcolors[item.level_no - 1].color}>
                                    <h2 className="mb-0">{item.level_no}</h2>
                                </ColorCircle>
                                <div className="ml-3">
                                    {item.pack_no == 4 ? <h5 className="m-0">LEVEL {item.level_no}. Full Level.</h5> : <h5 className="m-0">LEVEL {item.level_no}. Pack {item.pack_no}.</h5>}
                                    {item.pack_no == 1 && <div className="color-text-grey">You are buying Games 1-20</div>}
                                    {item.pack_no == 2 && <div className="color-text-grey">You are buying Games 21-35</div>}
                                    {item.pack_no == 3 && <div className="color-text-grey">You are buying Games 36-50</div>}
                                    {item.pack_no == 4 && <div className="color-text-grey">You are buying Games 1-50</div>}

                                    <div>Price: <span className="ml-2 color-orange">£{item.effective_price}</span></div>
                                </div>
                            </Card>
                        })}

                    </Col>
                    <Col lg={4} className="mt-3">
                        <Card className="p-4">
                            <h5 className="color-text-green text-center mb-0">Summary</h5>
                            <div className="d-flex justify-content-between mt-2">
                                <span className="color-text-grey">Items in your bag</span>
                                <span className="color-text-green">{basketContents.length}</span>
                            </div>
                            <div className="d-flex justify-content-between mt-2">
                                <span className="color-text-grey">Subtotal</span>
                                <span className="color-text-green">£{basketData && basketData.total_price}</span>
                            </div>
                            <div className="d-flex justify-content-between mt-3">
                                <h5>TOTAL</h5>
                                <h5 className="color-text-green">£{basketData && basketData.total_price}</h5>
                            </div>
                            {/* <Link to="/store/checkout"> */}

                            <CustomButton onClick={() => Checkout()} className="w-100 mt-4" bgColor={COLORS.orange} hover={COLORS.orange_hover} color={COLORS.dark_orange}>Proceed to Checkout</CustomButton>
                            {/* </Link> */}

                        </Card>
                    </Col>
                </Row>
            </MainLayout>
        );
    }

}

export default Basket;